export default {
      id: "playNext-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#playNext-usage",
      toString: function () {
        return this.url;
      }
    }